module.exports = __webpack_public_path__ + "static/img/imgLoading.6717a533.gif";